// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../accordion';
import ProductItem from './product-item';

const ProductLevel = props =>
    <ul>
        {props.products.map(product =>
            <li key={product.code}>
                {product.productHierarchy && product.productHierarchy.length ? (
                    <Accordion
                        accordionId={`${product.code}`}
                        body={
                            <ProductLevel
                                products={product.productHierarchy}
                                selectedProduct={props.selectedProduct}
                            />
                        }
                        title={
                            <ProductItem
                                isProductSelected={product.code === props.selectedProduct}
                                product={product}
                            />
                        }
                    />
                ) : (
                    <ProductItem
                        isProductSelected={product.code === props.selectedProduct}
                        product={product}
                    />
                )}
            </li>
        )}
    </ul>;

ProductLevel.displayName = 'ProductLevel';
ProductLevel.propTypes = {
    products: PropTypes.arrayOf(
        PropTypes.shape({
            code: PropTypes.string,
            description: PropTypes.string,
            productHierarchy: PropTypes.array
        })
    ).isRequired,
    selectedProduct: PropTypes.string
};
ProductLevel.contextTypes = {
    onProductHierarchyChange: PropTypes.func
};

export default ProductLevel;



// WEBPACK FOOTER //
// ./src/shared/components/facets/product-hierarchy/product-level.js